import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import { persistReducer } from 'redux-persist';
import { authReducer } from './authSlice/authSlice';
import { recipesReducer } from './recipesSlice/recipesSlice';
import { filterReducer } from './filterSlice';
import { favoritesReducer } from './favoritesSlice/favoretesSlice';
import { shoppingReducer } from './shoppingSlice/shoppingSlice';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};

export const store = configureStore({
  reducer: {
    auth: persistReducer(authPersistConfig, authReducer),
    recipes: recipesReducer,
    filter: filterReducer,
    favorites: favoritesReducer,
    shoppingList: shoppingReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV === 'development',
});

export let persistor = persistStore(store);
